const tableFilters = {
    state: {

        filters: {},

    },
    mutations: {

        setFilters(state, payload){
            //Set the filters
            state[payload.key] = payload.filters;
        },

        setFiltersAlt(state, payload){
            //Set the filters
            state.filters[payload.key] = payload.filters;
        },

    },
    actions: {}
}

export default tableFilters;
